import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import HpLazyImageWrapper from '../HpLazyImageWrapper/HpLazyImageWrapper';
import ResponsiveImage from '../ResponsiveImage';

import styles from './HpRespCollectionsModuleItem.scss';

import { HpRespCollectionsModuleItem_item } from './__generated__/HpRespCollectionsModuleItem_item.graphql';

type Props = {
    item: HpRespCollectionsModuleItem_item;
    useLazyLoadImages: boolean;
    onClick: () => void;
};

const HpRespCollectionsModuleItem: FC<Props> = ({ item, onClick, useLazyLoadImages }) => {
    const { title, imageUrl, linkData } = item;

    return (
        <SeoLink
            linkData={linkData}
            className={styles.link}
            onClick={onClick}
            dataTn="collections-item-link"
        >
            <HpLazyImageWrapper useLazyLoad={useLazyLoadImages} className={styles.imageWrapper}>
                <ResponsiveImage
                    className={styles.image}
                    src={imageUrl || ''}
                    // no need for alt if title is present bc labeling the img with title is
                    // redundant with title as link text. only use alt if != title.
                    ariaHidden={!!title}
                    dataTn="collections-item-image"
                    srcSetWidths={[120, 150]}
                />
            </HpLazyImageWrapper>
            <span className={styles.title} data-tn="collections-item-title">
                {title}
            </span>
        </SeoLink>
    );
};

export default createFragmentContainer(HpRespCollectionsModuleItem, {
    item: graphql`
        fragment HpRespCollectionsModuleItem_item on Product {
            title
            imageUrl
            linkData {
                ...SeoLink_linkData
            }
        }
    `,
});
